export default __webpack_public_path__ + "img/6ec3bbe8c900382733c63452381d26e1.png";